/**
 * Use a stub for MaskedView on all Platforms that don't support it.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MaskedView", {
    enumerable: true,
    get: function() {
        return MaskedView;
    }
});
function MaskedView({ children }) {
    return children;
}

//# sourceMappingURL=MaskedView.js.map
